interface ArrowRightIconProps {
  size?: number;
  color?: string;
  className?: string;
}

/**
 * Arrow up icon
 * Source: frontend/assets/icons/arrow-up.svg
 */
export default function ArrowRightIcon({ 
  size = 12, 
  color = 'currentColor',
  className 
}: ArrowRightIconProps) {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 12 12"
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M6.25 9.25L9.21716 6.28284C9.37337 6.12663 9.37337 5.87337 9.21716 5.71716L6.25 2.75" 
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round"
      />
    </svg>
  );
}
